import { types, actions } from './requests'
export const CREATEARTICLEIMPORT_TYPES = {
    ...types('CREATEARTICLEIMPORT'),
}
export const CREATEARTICLEIMPORT_ACTIONS = {
    ...actions('CREATEARTICLEIMPORT'),
}